////////////////////////////////////////////////////////////////////////
///////// DEBUT segmentation des filtre en fonction de la location du market ////////

// fonction pour creer une nodelist pour chaque element id commençant par le même prefixe
function getElementIdByPrefix(prefixe) {
  const elementsGetByPrefix = document.querySelectorAll(`[id^="${prefixe}"]`);
  return elementsGetByPrefix;
}
const currencyElement = document.querySelector('[data-currency]');

if(document.getElementById('main-collection-filters')) {
  const usFilterDesktopNodelist = getElementIdByPrefix("Details-filter.p.m.custom.us_");
  const caFilterDesktopNodelist = getElementIdByPrefix("Details-filter.p.m.custom.ca_");
  const usFilterMobileNodelist = getElementIdByPrefix("Details-Mobile-filter.p.m.custom.us_");
  const caFilterMobileNodelist = getElementIdByPrefix("Details-Mobile-filter.p.m.custom.ca_");

  const usFilterDesktopArray = Array.from(usFilterDesktopNodelist);
  const caFilterDesktopArray = Array.from(caFilterDesktopNodelist);
  const usFilterMobileArray = Array.from(usFilterMobileNodelist);
  const caFilterMobileArray = Array.from(caFilterMobileNodelist);

  const usFilter = usFilterDesktopArray.concat(usFilterMobileArray);
  const caFilter = caFilterDesktopArray.concat(caFilterMobileArray);


  //condition d'affichage du filte en fonction de la location
  if (currencyElement.dataset.currency === 'CAD') {
    usFilter.forEach(element => {
      element.style.display = 'none';
    });
    caFilter.forEach(element => {
      element.style.display = 'block';
    });
  } else if (currencyElement.dataset.currency === 'USD') {
    caFilter.forEach(element => {
      element.style.display = 'none';
    });
    usFilter.forEach(element => {
      element.style.display = 'block';
    });
  } else {
    caFilter.forEach(element => {
      element.style.display = 'none';
    });
    usFilter.forEach(element => {
      element.style.display = 'none';
    });
  }
}
///////// FIN segmentation des filtre en fonction de la location du market ////////
////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////
///////// DEBUT script pour gérer l'affichage du sticky dans la pdp ////////
document.addEventListener('DOMContentLoaded', () => {
  const isPDP  = document.querySelector('.product__info-container');

  if (isPDP) {
    const priceToMove = document.querySelector('.price--large').parentElement;
    const quantityToMove = document.querySelector('.product-form__quantity');
    const addToCartToMove = document.querySelector('.product-form');
    const baseToAppend = document.querySelector('product-info');

    wrapCurency();

    function addMobilestyckyActionProduct (){
      let containerStycky = document.createElement('div');
      containerStycky.appendChild(priceToMove);
      containerStycky.appendChild(quantityToMove);
      containerStycky.appendChild(addToCartToMove);
      baseToAppend.appendChild(containerStycky);
    }

    if (window.innerWidth < 750) {
      addMobilestyckyActionProduct();
      document.body.classList.add('is-small-device');
    }
  }
});
///////// FIN script pour gérer l'affichage du sticky dans la pdp /////////
////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////
///////// DEBUT gestion des items du menu fonction de la location du market ////////
const ItemsMenu = document.querySelectorAll('a.header__menu-item');

ItemsMenu.forEach(element => {
  const urlString = element.href;
  if (currencyElement.dataset.currency === 'USD' && urlString.includes('custom.ca_')) {
    // Remplacer 'CA_' par 'US_'
    const urlAjuste = urlString.replace('custom.ca_', 'custom.us_');
    element.href = urlAjuste;
  } else if (currencyElement.dataset.currency === 'CAD' && urlString.includes('custom.us_')) {
    // Remplacer 'US_' par 'CA_'
    const urlAjuste = urlString.replace('custom.us_', 'custom.ca_');
    element.href = urlAjuste;
  }
});
///////// FIN gestion des items du menu fonction de la location du market ////////
////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////
///////// DEBUT gestion des url des page avec filtre au changement de location du market ////////
const locatorChangeLink = document.querySelectorAll('.disclosure__link');
const currentUrlPage = window.location.href;

locatorChangeLink.forEach(link => {
  link.addEventListener('click', (e) => {
    const urlInput = e.target.closest('form.localization-form').querySelector('[name="return_to"]');
    if (currentUrlPage.includes('custom.ca_') && link.dataset.value === "US") {
      urlInput.value = urlInput.value.replace('custom.ca_', 'custom.us_');
    } else if (currentUrlPage.includes('custom.us_') && link.dataset.value === "CA") {
      urlInput.value = urlInput.value.replace('custom.us_', 'custom.ca_');
    }
  });
});
///////// FIN gestion des url des page avec filtre au changement de location du market ////////
////////////////////////////////////////////////////////////////////////


////////////////////////////////////////////////////////////////////////
///////// DEBUT script pour gérer l'affichage du sticky dans la pdp ////////
document.addEventListener('DOMContentLoaded', () => {
  const isPDP  = document.querySelector('.product__info-container');

  if (isPDP) {
    const currentProductId = document.querySelector('product-info').getAttribute('data-product-id')
    const productInCarrousselCollection = document.querySelectorAll("[data-secondary-product-is]")

    productInCarrousselCollection.forEach(element => {
      const productInCarrousselCollectionId = element.getAttribute('data-secondary-product-is');
      if (productInCarrousselCollectionId === currentProductId) {
        element.remove();
      }
    });
  }
});
///////// FIN script pour gérer l'affichage du sticky dans la pdp /////////
////////////////////////////////////////////////////////////////////////